export default "# Source Code References\n\n[Here you can insert the source code references for this software...]"